import { ContentfulContentRow } from "../contentful-content-row/contentful-content-row";
import { ContentfulHeadlineBlock } from "../contentful-headline-block/contentful-headline-block";

export class ContentfulGenericPage {
    contentRows: ContentfulContentRow[]
    heroBlock: ContentfulHeadlineBlock
    bodyHasHeader: boolean
}
